import AuthenticatedLayout from '@/Layouts/Auth/AuthenticatedLayout';
import {Head} from '@inertiajs/react';
import {PageProps, UserSettings} from '@/types';
import UpdateSettingsForm from "@/Pages/Settings/Partials/UpdateSettingsForm";
import React from "react";
import PageLayout from "@/Layouts/PageLayout";

export default function Edit({settings}: PageProps<{
    settings: UserSettings
}>) {
    return (
        <PageLayout
            header={<h2 className="font-semibold text-xl text-gray-800 dark:text-gray-100 leading-tight">Settings</h2>}
        >
            <Head title="Settings"/>

            <div className="py-12 mx-2 md:mx-0">
                <div className="max-w-6xl mx-auto px-2 ">
                    <div className=" bg-white dark:bg-gray-800 shadow rounded-lg">
                        <header className="px-6 md:px-8 pt-6 pb-4">
                            <h2 className="text-xl font-medium text-gray-900 dark:text-gray-100">Preferences</h2>
                            <p className=" text-base text-gray-600 dark:text-gray-400">
                                Update your preferences
                            </p>
                        </header>
                        <div className="">
                            <UpdateSettingsForm settings={settings}/>
                        </div>
                    </div>

                </div>
            </div>
        </PageLayout>
    );
}
